import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { CacheService } from '@barthauer/abc/core/data';
import { Observable, of } from 'rxjs';
import { concatMap, retry } from 'rxjs/operators';

export abstract class WebApiService {
  public static readonly HTTP_HEADER_AVOID_AUTH_HEADERS: string = 'AvoidAuthHeaders';

  constructor(private httpClient: HttpClient, protected abcConfigService: AbcConfigService) {}

  protected executeWebApiPOST(
    url: string,
    body: any,
    avoidAuthHeaders: boolean = false,
    noRetry: boolean = false
  ): Observable<ArrayBuffer> {
    return this.getWebApiPOSTHeaders().pipe(
      concatMap((headerMap) => {
        const headerSettings: { [name: string]: string | string[] } = {};
        let headers: HttpHeaders = new HttpHeaders(headerSettings);

        headerMap.forEach((val, key, map) => (headers = headers.set(key, val)));

        if (avoidAuthHeaders) {
          headers = headers.set(WebApiService.HTTP_HEADER_AVOID_AUTH_HEADERS, 'true');
        }

        const options: any = {
          headers: headers,
          observe: 'body',
        };

        let result = CacheService.httpPostStatic(
          this.httpClient,
          url,
          body,
          options,
          undefined,
          undefined,
          avoidAuthHeaders
        );
        if (!noRetry) {
          result = result.pipe(retry(this.abcConfigService?.configuration?.HttpPostRetryCount));
        }
        return result;
      })
    );
  }

  protected getWebApiPOSTHeaders(): Observable<Map<string, string>> {
    return of(new Map<string, string>([['Content-Type', 'application/json']]));
  }
}
